<form autocomplete="off" [formGroup]="phoneForm">
  <div class="flex justify-between items-baseline">
    <h4 class="user-profile-heading">Phones</h4>
    <button mat-icon-button matTooltip="Add Entry" [matMenuTriggerFor]="phoneMenu">
      <mat-icon class="plus">add</mat-icon>
    </button>
  </div>

  <div class="flex">
    <mat-menu #phoneMenu="matMenu">
      @for (content of phone_content; track content) {
        @if (!content.isSelected) {
          <button (click)="addPhoneType(content)" mat-menu-item>{{content.text}}</button>
        }
      }
    </mat-menu>
  </div>

  <div formArrayName="phones">
    @for (phone of phonesListArr.controls; track phone; let i = $index) {
      <ng-container [formGroupName]="i">
        <div class="flex gap-3 place-items-center">
          <mat-form-field class="w-[25%]">
            <mat-label>Type</mat-label>
            <mat-select disableOptionCentering matNativeControl formControlName="phone_type" [disabled]="phone?.value?.phone_class == 'true'" [ngClass]="{'line-through': phone?.value?.phone_class == 'true'}">
              @for (content of getFilteredPhoneContent(phone.value.phone_type); track content) {
                <mat-option value="{{content.text}}">{{content.text}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="w-[43%]">
            <mat-label>Phone</mat-label>
            <input [class]="phone?.value?.phone_class == 'true' ? 'not-allowed' : ''"  matInput formControlName="phone" appPhoneNumberMask [maxlength]="14" [readonly]="phone?.value?.phone_class == 'true'" [ngClass]="{'line-through': phone?.value?.phone_class == 'true'}" appDisableAutofill>
            @if (phone?.get('phone')?.errors && submitted) {
              <mat-error>
                Please enter correct phone number
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field class="w-[20%]">
            <mat-label>Ext ...</mat-label>
            <input [class]="phone?.value?.phone_class == 'true' ? 'not-allowed' : ''" [readonly]="phone?.value?.phone_class == 'true'"  matInput formControlName="phone_ext" [maxlength]="20" [ngClass]="{'line-through': phone?.value?.phone_class == 'true'}">
          </mat-form-field>
          @if (phone?.value?.phone_class == '') {
            <button mat-icon-button class="close" title="Undo" (click)="clearPhone( phone.value,i)"><mat-icon>close</mat-icon></button>
          }
          @if (phone?.value?.phone_class == 'true') {
            <button mat-icon-button (click)="refreshPhone(phone.value,i)"><mat-icon>replay</mat-icon></button>
          }
          @if (type!='admin') {
            <mat-checkbox matTooltip="Default Phone" [matTooltipDisabled]="phone?.value?.isSelected==false" (change)="phoneCheckBoxvalue($event,phone.value,i)" [checked]="phone?.value?.isSelected==true || type == 'plan' || type=='add-user'" [disabled]="phone?.value?.isDisabled && phone?.value?.phone.length != 14"></mat-checkbox>
          }
        </div>
      </ng-container>
    }

  </div>
</form>
